import { Component } from '@poa/core';
import { action, observable, selector } from '@poa/state';
import isEmpty from 'lodash/isEmpty';
import React from 'react';
import ReactDOM from 'react-dom';
import { ProfileModalContent } from './profile-modal-content';
import { ProfileModalHead } from './profile-modal-head';
import { ProfileModalLeftCorner } from './profile-modal-left-corner';
import { ProfileModalRightCorner } from './profile-modal-right-corner';

const modalEl = document.getElementById('modal');

export class ProfileModal extends React.Component {
  static defaultProps = {
    isOpened: true,
    profileId: -1
  };

  render() {
    const { isOpened, ...rest } = this.props;

    if (isOpened) {
      return ReactDOM.createPortal(<Modal {...rest} />, modalEl);
    }

    return null;
  }
}

const Modal = Component()(
  class Modal extends React.Component {
    store; // injected by Poa
    actions; // injected by Poa

    async componentDidMount() {
      try {
        // create mode
        if (this.props.profileId === -1) {
          this.localState.model = JSON.parse(JSON.stringify(this.getOriginalModel()));
          this.localState.isEditMode = true;
          this.localState.loading = false;
          this.localState.isAdding = true;
        } else {
          switch (this.props.variant) {
            case 'staff':
              await this.actions.usersActions.fetchUser(this.props.profileId, this.props.variant);
              this.localState.model = JSON.parse(JSON.stringify(this.getOriginalModel()));
              this.localState.loading = false;
              break;
            case 'credentials': {
              const model = await this.props.onFetch(this.props.profileId, this.props.variant);
              this.localState.originalModel = JSON.parse(JSON.stringify(model));
              this.localState.model = model;
              this.localState.loading = false;
              break;
            }
            case 'agency': {
              const model = await this.props.onFetch(this.props.profileId, this.props.variant);
              this.localState.originalModel = JSON.parse(JSON.stringify(this.getOriginalModel()));
              this.localState.model = model;

              const clone = { ...model };
              delete clone.labels;

              this.localState.isEmpty = isEmpty(clone);

              if (this.localState.isEmpty) {
                this.localState.model = Object.assign(this.getOriginalModel(), model.labels);
                this.localState.isAdding = true;
              } else {
                this.localState.sites = (await this.env.http.get('sites')).data;
                const availableSites = Object.keys(model).filter(key => key !== 'labels');

                availableSites.forEach(key => {
                  Object.assign(this.localState.model[key], this.localState.model.labels);
                });

                this.localState.selectedSite = +availableSites[0];
              }

              this.localState.loading = false;
              break;
            }
            default:
              await this.actions.usersActions.fetchUser(this.props.profileId, this.props.variant);
              this.localState.model = JSON.parse(JSON.stringify(this.getOriginalModel()));
              this.localState.loading = false;

              if (this.localState.model.salary.sites.find(s => s.id !== 'all')) {
                this.localState.model.salary.sites.unshift({ id: 'all', title: 'ВСЕ САЙТЫ' });
              }

              this.localState.salarySite = this.localState.model.salary.sites[0].id;

              break;
          }
        }

        document.body.classList.add('no-scroll');
      } catch (e) {
        console.error(e);
        this.onClose();
      }
    }

    componentWillUnmount() {
      document.body.classList.remove('no-scroll');
    }

    handleOutsideClick = e => {
      if (this.node && this.node.contains(e.target)) {
        return;
      }

      this.onCancel();
      this.onClose();
    };

    getOriginalModel() {
      if (this.props.profileId === -1) {
        switch (this.props.variant) {
          case 'staff':
            return {
              is_active: true,
              age: null,
              email: null,
              first_name: null,
              login: null,
              gender: null,
              group: null,
              group_id: null,
              site_id: null,
              last_name: null,
              lead_id: null,
              lead: null,
              level_id: null,
              phone: null,
              status: 'active',
              password: '',
              confirm: '',
              percent: null,
              percent_active: false,
              fixed_payment: null,
              fixed_payment_active: false
            };
          case 'credentials':
            return {
              login: '',
              title: '',
              password: '',
              confirm: ''
            };
          default:
            break;
        }
      }

      switch (this.props.variant) {
        case 'agency':
          return {
            account_default_percent: '',
            fee: '',
            include_calls: false,
            include_gifts: false,
            include_video: false,
            manager_default_percent: '',
            operator_default_percent: '',
            scout_default_percent: '',
            teamlead_default_percent: ''
          };

        default:
          break;
      }

      return this.store.users.data.find(user => user.id === this.props.profileId);
    }

    localState = observable({
      loading: true,
      isEditMode: true,
      model: null,
      isEmpty: false,
      isAdding: false,
      sites: [],
      selectedSite: null,
      originalModel: null,
      currentTab: 'questionnaire',
      galleryMode: false,
      salarySite: '',

      setAdding: () => {
        this.localState.model = observable(
          Object.assign(this.getOriginalModel(), this.localState.model.labels)
        );
      },

      getProps: () => this.props,

      get isFormValid() {
        if (this.getProps().variant === 'staff') {
          const data = this.model;

          if (this.isAdding) {
            if (!data.email) {
              return false;
            }

            if (!data.login) {
              return false;
            }

            if (!data.group_id) {
              return false;
            }

            if (!data.password || !data.confirm) {
              return false;
            }

            return !this.isPasswordMatched;
          } else {
            if (!data.email) {
              return false;
            }
            if (!data.group_id) {
              return false;
            }

            if (!data.login) {
              return false;
            }
          }
        }

        return !this.isPasswordMatched;
      },

      get isPasswordMatched() {
        const data = this.model;
        return data.password && data.confirm && data.password !== data.confirm;
      },

      get salaryDataFiltered() {
        return this.model.salary.data.tbody.filter(row => {
          const matched = [];

          row.data.forEach(salary => {
            if (this.salarySite !== 'all') {
              matched.push(salary.sites.includes(this.salarySite));
              return;
            }

            return matched.push(true);
          });

          return matched.every(m => m);
        });
      }
    });

    onClose = action(() => {
      this.props.requestClose();
    });

    onEdit = action(() => {
      this.localState.isEditMode = true;
    });

    onCancel = action(() => {
      if (this.props.profileId === -1) {
        this.onClose();
        return;
      }

      if (this.props.variant === 'agency') {
        this.onClose();
        return;
      }

      // TODO: we can't use lodash.cloneDeep since mobx..
      this.localState.model = JSON.parse(JSON.stringify(this.getOriginalModel()));
      this.localState.isEditMode = false;
    });

    onSave = action(async () => {
      this.localState.isEditMode = false;

      try {
        if (this.props.profileId === -1) {
          switch (this.props.variant) {
            case 'credentials':
            case 'agency':
              await this.props.onCreate(
                JSON.parse(JSON.stringify(this.localState.model)),
                this.localState.selectedSite
              );
              this.onClose();
              break;
            case 'staff':
              await this.actions.usersActions.createUser(
                JSON.parse(JSON.stringify(this.localState.model)),
                this.props.variant
              );
              this.onClose();
              break;
            default:
              await this.actions.usersActions.createUser(
                JSON.parse(JSON.stringify(this.localState.model)),
                this.props.variant
              );
              this.onClose();
              break;
          }
        } else {
          switch (this.props.variant) {
            case 'credentials':
            case 'agency':
              await this.props.onUpdate(
                this.props.profileId,
                JSON.parse(JSON.stringify(this.localState.model)),
                this.localState.selectedSite,
                this.localState.isAdding
              );
              this.onClose();
              break;
            case 'staff':
              await this.actions.usersActions.updateUser(
                JSON.parse(JSON.stringify(this.localState.model)),
                this.props.variant
              );
              break;
            default:
              await this.actions.usersActions.updateUser(
                JSON.parse(JSON.stringify(this.localState.model)),
                this.props.variant
              );
              break;
          }
        }
      } catch (e) {
        console.error(e);
        this.onCancel();
        this.onClose();
      }
    });

    selectedSite = selector(() => {
      switch (this.props.variant) {
        case 'staff':
          return null;
        case 'credentials':
        case 'agency':
          return null;
        default:
          return this.localState.model.sites.find(site => site.selected);
      }
    });

    onTabChange = newTab => {
      this.localState.currentTab = newTab;
    };

    onGalleryOpen = mode => {
      this.localState.galleryMode = mode;
    };

    onGalleryClose = () => {
      this.localState.galleryMode = null;
    };

    render() {
      if (this.localState.loading) {
        return (
          <div
            id='account-popup'
            className='popup is-open'
            style={{ display: 'block' }}
          >

          </div>);
      }

      return (
        <div
          id='account-popup'
          className='popup is-open'
          style={{ display: 'block' }}
          onClick={this.handleOutsideClick}
        >
          <div className='popup__inner' ref={node => (this.node = node)}>
            <div className='popup__top'>
              <ProfileModalLeftCorner
                state={this.localState}
                requestGalleryClose={this.onGalleryClose}
              />
              <ProfileModalHead
                selectedSite={this.selectedSite}
                state={this.localState}
                variant={this.props.variant}
              />
              <ProfileModalRightCorner
                onClose={this.onClose}
                onEdit={this.onEdit}
                onSave={this.onSave}
                onCancel={this.onCancel}
                state={this.localState}
              />
            </div>
            <ProfileModalContent
              state={this.localState}
              selectedSite={this.selectedSite}
              requestTabChange={this.onTabChange}
              requestGallery={this.onGalleryOpen}
              variant={this.props.variant}
            />
          </div>
        </div>
      );
    }
  }
);
